import {
  IonButton,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonLoading,
  IonSelect,
  IonSelectOption,
  IonToast,
  IonToggle,
  useIonAlert,
  IonicSafeString,
  IonIcon,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonModal,
  IonRadio,
  IonRadioGroup,
  IonTitle,
  IonToolbar,
  IonFab,
  IonFabButton,
} from "@ionic/react";
import moment from "moment";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useHistory, useParams } from "react-router-dom";
import { decodeParam, encodeParam } from "../util/ApiHelper";
import { getTimeEntryAccess, getUserId } from "../util/UserHelper";
import { WorkOrder } from "../models/workorders/WorkOrder";
import {
  TranslationMessagesContext,
  TranslationsContext,
} from "../util/Translations";
import ApiError from "./ApiError";
import { Employee } from "../models/employees/Employees";
import { findEmployee, getEmployeesLiteList } from "../api/Employees";
import {
  add,
  caretDownOutline,
  caretDownSharp,
  filterCircleOutline,
  filterCircleSharp,
  searchOutline,
  searchSharp,
} from "ionicons/icons";
import { getValueSearchDetails } from "../api/QueryDesigner";
import { ApiResponse } from "../models/api/ApiResponse";
import FilterModal from "./FilterModal";
import ISSPopover from "./ISSPopover";
import { logCustomMessage } from "../util/logger";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import TimeEntry from "../pages/TimeEntry";
import { reactPlugin } from "../util/AppInsights";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { useOfflineStore } from "../store/offline-mode";
import useGetWorkOrder from "../hooks/useGetWorkOrder";
import { useWorkOrderStore } from "../store/wo-order";
import { useShallow } from "zustand/react/shallow";
import useGetWoCompletionFields from "../hooks/work-order/useGetUserValidValues";
import useGetDefaultWOCompletionStatus from "../hooks/work-order/useGetDefaultWOCompletionStatus";
import useGetComments from "../hooks/work-order/useGetComments";
import useCompleteWo from "../hooks/work-order/useCompleteWo";
import { useWoOfflineUpdatesStore } from "../store/wo-offline-updates";
import { RemarksCollection } from "../models/remarks/RemarksCollection";
import useGetValidStatusValues from "../hooks/work-order/useGetValidStatusValues";
interface ValidValues {
  Code: string;
  Description: string;
}

const CompletionData: React.FC = () => {
  const { translations } = useContext(TranslationsContext);
  const { translatedMessages } = useContext(TranslationMessagesContext);

  const { workOrderId, offlineWoId } = useParams<{
    workOrderId: string;
    offlineWoId: string;
  }>();
  const history = useHistory();
  const displayWo = decodeParam(workOrderId);
  const [showLoading, setShowLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState<string>();
  const [toastStatus, setToastStatus] = useState<"success" | "danger">();
  const [status, setStatus] = useState<string>();
  const [userId, setUserId] = useState<string>();
  const [startDateTime, setStartDateTime] = useState<string>();
  const [endDateTime, setEndDateTime] = useState<string>();
  const [lostProduction, setLostProduction] = useState<string>();
  const [productionUom, setProductionUom] = useState<string>();
  const [failure, setFailure] = useState<boolean>(false);
  const [followUpFlag, setFollowUpFlag] = useState<boolean>(false);
  const [errorData, setErrorData] = useState("");
  const [_, setEmployees] = useState<Employee[]>([]);
  const [comments, setComments] = useState<string>();
  const [showModal, setShowModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [filter, setFilter] = useState("");
  const [filterModalColumnName, setFilterModalColumnName] = useState("");
  const [filterModalModuleName, setFilterModalModuleName] = useState("");
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [searchResults, setSearchResults] = useState<string[]>([]);
  const [searchValue, setSearchValue] = useState("");
  const popover = useRef<HTMLIonPopoverElement>(null);
  let [filteredReviewerList] = useState<ValidValues[]>([]);
  const [timeAccess, setTimeAccess] = useState(false);
  const [objectID, setObjectID] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [presentAlert] = useIonAlert();
  const { getValidStatusValues } = useGetValidStatusValues();

  const isOffline = useOfflineStore((state) => state.isOffline);
  const workOrder = useWorkOrderStore(
    useShallow((state) => state.getWorkOrderById(displayWo))
  );
  const fields = useWorkOrderStore(
    useShallow((state) => state.woCompletionFields)
  );
  const woDefaultCompletionStatus = useWorkOrderStore(
    useShallow((state) => state.woDefaultCompletionStatus)
  );
  const eventComments = useWorkOrderStore(
    useShallow((state) => state.getCommentsForWo(displayWo))
  );
  const { trigger } = useGetWorkOrder();
  const { getWoCompletionFields } = useGetWoCompletionFields();
  const { getDefaultWOCompletionStatus } = useGetDefaultWOCompletionStatus();
  const { getComments } = useGetComments();
  const { completeWorkOrder } = useCompleteWo();
  const addWoToComplete = useWoOfflineUpdatesStore(
    (state) => state.addWoToComplete
  );
  const updateById = useWoOfflineUpdatesStore((state) => state.updateById);
  const offlineWoToComplete = useWoOfflineUpdatesStore((state) =>
    state.getWoToCompleteById(offlineWoId)
  );
  const commentField = (fields ?? []).find(
    (field) => field.ColumnName === "remarks"
  );
  const userValidData = fields?.length
    ? fields.filter((field) => field.ColumnName === "user_id")[0].ValidValues ??
      []
    : [];

  const statusField = (fields ?? []).find((field) => {
    return field.ColumnName === "status";
  });
  const validStatusValues = statusField?.ValidValues
    ? statusField.ValidValues.filter((value) => {
        return +value.Code >= 70 && +value.Code < 80;
      })
    : [];

  const setOfflineExistingValues = useCallback(() => {
    if (!offlineWoId || !offlineWoToComplete) return;
    const { RequestObject } = offlineWoToComplete;
    const events = RequestObject.WorkOrder.Events;
    setStatus((RequestObject.WorkOrder.Status ?? "").toString());
    setUserId(events.UserId);
    const startDate = moment.utc(events?.StartDate);
    setStartDateTime(startDate.local().format(moment.HTML5_FMT.DATETIME_LOCAL));
    const endDate = moment.utc(events?.EventEndDate);
    setEndDateTime(endDate.local().format(moment.HTML5_FMT.DATETIME_LOCAL));
    setLostProduction(events.ProductionLost);
    setProductionUom(RequestObject.WorkOrder.EquipmentMaster.ProductionUom);
    setFailure(events.FailureFlag);
    setFollowUpFlag(events.FollowupRequiredFlag);
    const remarks = RemarksCollection.fromString(events.Comment.Remarks);
    setComments(
      remarks.length > 0 ? remarks[remarks.length - 1].comment ?? "" : ""
    );
  }, [offlineWoId, offlineWoToComplete]);

  useEffect(() => {
    if (workOrder && !offlineWoId)
      setExistingValues(workOrder, woDefaultCompletionStatus);
    else if (offlineWoId && offlineWoToComplete) setOfflineExistingValues();
  }, [
    offlineWoId,
    offlineWoToComplete,
    setOfflineExistingValues,
    woDefaultCompletionStatus,
    workOrder,
  ]);

  const getEventsData = useCallback(async () => {
    if (eventComments !== undefined) return; //got it in the cache
    await getComments(displayWo);
  }, [displayWo, eventComments, getComments]);

  const getWorkOrder = useCallback(async () => {
    if (workOrder) return; //got it from the cache
    const woResponse = await trigger(displayWo);

    const woData = {
      woNumber: workOrderId,
      events: true,
    };

    logCustomMessage(
      "Get Work Order in Complete screen",
      SeverityLevel.Information,
      "WorkOrders/Get",
      woData,
      woResponse
    );
    if (woResponse.isError) setErrorData(woResponse.data);
  }, [displayWo, trigger, workOrder, workOrderId]);

  const getCompletionDataFields = useCallback(async () => {
    if (fields) return; //got it from the cache
    await getWoCompletionFields();
  }, [fields, getWoCompletionFields]);

  const getDefaultStatus = useCallback(async () => {
    if (woDefaultCompletionStatus !== undefined) return; //got it in the cache
    await getDefaultWOCompletionStatus();
  }, [getDefaultWOCompletionStatus, woDefaultCompletionStatus]);

  const getEmployees = useCallback(async () => {
    if (isOffline) return []; //we will not be fetching this in offline
    const data = {
      PropertyList: ["EmployeeName", "EmployeeId"],
      Filter: "",
    };
    const response = await getEmployeesLiteList(data);
    logCustomMessage(
      "Getting Employees in Complete screen",
      SeverityLevel.Information,
      "Employees/GetLiteList",
      data,
      response
    );
    return response.data as Employee[];
  }, [isOffline]);

  const setup = useCallback(async () => {
    setShowLoading(true);

    await getWorkOrder();
    await getCompletionDataFields();
    const employees = await getEmployees();
    setEmployees(employees ?? []);
    await getDefaultStatus();
    getEventsData();
    setShowLoading(false);
  }, [
    getCompletionDataFields,
    getDefaultStatus,
    getEmployees,
    getEventsData,
    getWorkOrder,
  ]);

  useEffect(() => {
    getTimeAccess();
    if (displayWo) {
      setup();
    }
  }, [displayWo, setup]);

  if (
    (fields ?? []).find((x) => x.ColumnName === "user_id")?.ElementType !==
    "ISS"
  ) {
    filteredReviewerList = userValidData.filter(
      (card) =>
        card.Code.toLowerCase().includes(filter.toLowerCase()) ||
        card.Description.toLowerCase().includes(filter.toLowerCase())
    );
  }

  const setExistingValues = async (
    workOrder: WorkOrder,
    defaultStatus?: string
  ) => {
    const status = workOrder.Status;
    if (status && status >= 70 && status < 80) {
      setStatus(String(status));
    } else {
      setStatus(defaultStatus);
    }

    const events = workOrder.Events;
    const alreadyCompleted = !!events?.WoCompleteFlag;
    const userId = alreadyCompleted ? events.UserId : await getUserId();
    setUserId(userId ?? undefined);

    const startDate = moment.utc(events?.StartDate);
    if (startDate.isValid() && events?.StartDate !== "0001-01-01T00:00:00") {
      setStartDateTime(
        startDate.local().format(moment.HTML5_FMT.DATETIME_LOCAL)
      );
    } else {
      setStartDateTime(undefined);
    }

    const endDate = moment.utc(events?.EventEndDate);
    if (
      endDate.isValid() &&
      events?.EventEndDate !== "0001-01-01T00:00:00" &&
      alreadyCompleted
    ) {
      setEndDateTime(endDate.local().format(moment.HTML5_FMT.DATETIME_LOCAL));
    } else {
      setEndDateTime(moment().local().format(moment.HTML5_FMT.DATETIME_LOCAL));
    }

    const lostProduction = events?.ProductionLost;
    if (lostProduction && alreadyCompleted) {
      setLostProduction(String(lostProduction));
    } else {
      setLostProduction(undefined);
    }

    const productionUom = workOrder.EquipmentMaster?.ProductionUom;
    if (productionUom && alreadyCompleted) {
      setProductionUom(String(productionUom));
    } else {
      setProductionUom(undefined);
    }

    const failure = events?.FailureFlag;
    setFailure(!!failure && alreadyCompleted);

    const followUpFlag = events?.FollowupRequiredFlag;
    setFollowUpFlag(!!followUpFlag && alreadyCompleted);
  };

  const handleOfflineAlertDismiss = useCallback(() => {
    if (followUpFlag) {
      //Navigate to create work order if the follow up required flag is true.
      history.replace(
        `/quick-work-order/equipment/${encodeParam(
          `${workOrder?.Equipment}`
        )}/${encodeParam(workOrderId)}/create`
      );
    } else {
      // Navigate back
      history.goBack();
    }
  }, [followUpFlag, history, workOrder?.Equipment, workOrderId]);

  const onSubmit = async () => {
    const Status = !!status ? +status : null;
    const statusToSet = Status !== null ? String(Status) : "";
    const UserId = !!userId ? userId : null;
    const StartDate = !!startDateTime
      ? moment(startDateTime).utc().toISOString()
      : null;
    const StartTime = !!startDateTime
      ? moment(startDateTime).utc().format("hh:mm")
      : null;
    const EventEndDate = !!endDateTime
      ? moment(endDateTime).utc().toISOString()
      : null;
    const EventEndTime = !!endDateTime
      ? moment(endDateTime).utc().format("hh:mm")
      : null;
    const EventStatus = "Closed";
    const ProductionLost = !!lostProduction ? +lostProduction : null;
    const ProductionUom = !!productionUom ? productionUom : null;
    const FailureFlag = String(failure);
    const FollowupRequiredFlag = String(followUpFlag);
    let existingComments = eventComments;
    let modComment = "";
    if (comments) {
      let userInfo = userId;
      const currentDate = new Date();
      const options: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      const formattedDate = currentDate.toLocaleDateString("en-CA", options); // 'en-CA' locale formats the date as YYYY-MM-DD
      const formattedTimeWithTimeZone = currentDate.toLocaleTimeString(
        undefined,
        {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }
      );
      const commentDate = `${formattedDate} ${formattedTimeWithTimeZone}`;
      let userDateTime = `\r\n===== ${userInfo}, ${commentDate} =====\r\n`;
      let footer = "\r\n\r\n=====";
      modComment = userDateTime + comments + footer;
    }
    const Remarks = existingComments + modComment;
    const body = {
      Confirmation: {
        RuleConfirmationDetailsList: [],
      },
      RequestObject: {
        WorkOrder: {
          ...workOrder,
          Status,
          Events: {
            ...workOrder?.Events,
            UserId,
            StartDate,
            StartTime,
            EventStatus,
            EventEndDate,
            EventEndTime,
            ProductionLost,
            FailureFlag,
            FollowupRequiredFlag,
            Comment: {
              Remarks,
            },
            EmployeeId: userId,
          },
          EquipmentMaster: {
            ...workOrder?.EquipmentMaster,
            ProductionUom,
          },
        },
      },
    };
    if (isOffline) {
      const data = { ...body, woNumber: displayWo };

      const isEditing = !!(typeof offlineWoId === "string"
        ? offlineWoId.trim()
        : "");

      console.log(
        `completion data for offline with id '${offlineWoId}' & isEditing - ${isEditing}`
      );

      isEditing ? updateById(offlineWoId, data) : addWoToComplete(data);
      presentAlert({
        message: `${
          translatedMessages["MobOfflineWOCmpSaveSuccess"]?.MessageText ||
          "Wo Completion Saved Successfully In Offline Store."
        }`,
        buttons: [
          {
            text: translations["lbl_btn_ok"] || "OK",
            handler: handleOfflineAlertDismiss,
          },
        ],
        onDidDismiss: handleOfflineAlertDismiss,
      });
      return; //we will complete it once user is back online
    }
    completeWo(body, statusToSet);
  };

  const onModalCancel = () => {
    setIsModalOpen(false);
  };
  const onModalConfirm = () => {
    setIsModalOpen(false);
  };

  const completeWo = async (body: any, Status?: string) => {
    setShowLoading(true);
    const response = await completeWorkOrder(body, displayWo);
    if (!response) {
      setShowLoading(false);
      return;
    }

    if (response.data && response.data.MessageList) {
      // Check if any message is a confirmation prompt (MessageType === 1 with ValidResponses)
      const confirmationMessage = response.data.MessageList.find(
        (message: any) =>
          message.MessageType === 1 &&
          message.ValidResponses &&
          message.ValidResponses.length > 0
      );

      if (confirmationMessage) {
        setShowLoading(false);
        const abortResponse = confirmationMessage.ValidResponses.find(
          (r: any) => r.Action === "Abort"
        );
        const continueResponse = confirmationMessage.ValidResponses.find(
          (r: any) => r.Action === "Continue"
        );

        presentAlert({
          header: confirmationMessage.Text,
          backdropDismiss: false,
          buttons: [
            {
              text: abortResponse?.DisplayText || "No",
              role: "cancel",
            },
            {
              text: continueResponse?.DisplayText || "Yes",
              handler: () => {
                const confirmationBody = {
                  ...body,
                  Confirmation: {
                    RuleConfirmationDetailsList: [
                      {
                        MessageId: confirmationMessage.Id,
                        MessageConfirmationValue: {
                          val1: continueResponse?.ResponseValue || "Y",
                        },
                      },
                    ],
                  },
                };
                completeWo(confirmationBody, Status);
              },
            },
          ],
        });
        return;
      }

      const messages: string[] = response.data?.MessageList?.map(
        (message: { Text: string }) => {
          return message.Text;
        }
      );
      setToastStatus(response.data.Success ? "success" : "danger");
      setToastMessage(
        `<span style="overflow-wrap:anywhere">${messages
          .join(" ")
          .replace(/\r\n/g, "<br>")}</span>`
      );
      setShowToast(true);
      if (response.data.Success && followUpFlag) {
        //Navigate to create work order if the follow up required flag is true.
        history.push(
          `/quick-work-order/equipment/${encodeParam(
            `${workOrder?.Equipment}`
          )}/${encodeParam(workOrderId)}/create`
        );
      }
    }
    const woResponse = await trigger(displayWo);
    const data = {
      woNumber: displayWo,
    };
    logCustomMessage(
      "Save time entry.",
      SeverityLevel.Information,
      "Labors/Put",
      data,
      woResponse
    );
    if (woResponse.isError) {
      setErrorData(woResponse.data);
    } else {
      const updatedWorkOrder = woResponse.data as WorkOrder;
      updatedWorkOrder && setExistingValues(updatedWorkOrder, Status);
      await getValidStatusValues(displayWo);
      // Bug 926622 - only leave the Completion screen when the server accepted the completion.
      // On failure, stay here so the error toast (mounted in this page) remains readable.
      if (response.data?.Success) {
        if (followUpFlag) {
          // Navigate to create work order if the follow-up flag is true
          history.replace(
            `/quick-work-order/equipment/${encodeParam(
              `${workOrder?.Equipment}`
            )}/${encodeParam(workOrderId)}/create`
          );
        } else {
          // Navigate back to the work order detail screen
          history.goBack();
        }
      } else if (response.isError) {
        // HTTP-level failure has no MessageList, so no toast was shown - surface it via ApiError.
        setErrorData(response.data);
      }
    }
    setShowLoading(false);
  };

  const handleClose = () => {
    setSelectedEmployee(userId ?? ""); // Reset selected reviewer
    setShowModal(false);
  };

  const handleRadioChange = (e: any) => {
    setSelectedEmployee(e.detail.value);
  };

  const handleOk = () => {
    setUserId(selectedEmployee);
    setShowModal(false);
  };

  const resetSearchState = () => {
    setFilterModalColumnName("");
    setFilterModalModuleName("");
  };

  const onFilterModalConfirm = (
    selectedItem: string | number | null | undefined
  ) => {
    setParameter(filterModalColumnName, selectedItem);
    setIsFilterModalOpen(false);
    resetSearchState();
  };

  const setParameter = (
    paramKey: string,
    paramValue: string | number | null | undefined
  ) => {
    if (paramKey === "employee_id") {
      setUserId(paramValue as string);
    }
  };

  const getTimeAccess = async () => {
    const userAccess = await getTimeEntryAccess();
    setTimeAccess(userAccess);
  };

  const handleEmployeeSearch = (e: CustomEvent) => {
    let newVal = (e.target as HTMLInputElement)?.value;
    setUserId(newVal);
    if (newVal.length > 2) {
      findEmployee(newVal).then((response) => {
        const data = {
          Search: newVal,
        };
        logCustomMessage(
          "Finding employees with typeAhead in Complete screen",
          SeverityLevel.Information,
          "Employees/Find",
          data,
          response
        );
        if (response.status === 200) {
          if (Object.keys(response.data).length !== 0) {
            popover.current!.event = e;
            setPopoverOpen(true);
          } else if (popoverOpen) {
            setPopoverOpen(false);
          }
          let empSearchArray = [];
          const employees = Object.entries(response.data).map(([id, name]) => ({
            EmployeeId: id,
            EmployeeName: name,
          }));
          for (let search of employees) {
            empSearchArray.push(search.EmployeeId);
          }
          setSearchResults(empSearchArray);
        }
      });
    } else {
      if (popoverOpen) {
        setPopoverOpen(false);
      }
      if (searchResults.length > 0) {
        setSearchResults([]);
      }
    }
  };

  return (
    <>
      <ApiError errorData={errorData} />
      <IonLoading isOpen={showLoading} />
      <FilterModal
        isOpen={isFilterModalOpen}
        moduleName={filterModalModuleName}
        cancel={() => setIsFilterModalOpen(false)}
        confirm={onFilterModalConfirm}
      />
      <IonToast
        isOpen={showToast}
        duration={5000}
        position="top"
        onDidDismiss={() => {
          setShowToast(false);
        }}
        color={toastStatus}
        message={new IonicSafeString(`${toastMessage}`)}
      />
      <IonList lines="full">
        {(fields ?? []).map((field, index) => {
          if (
            field.ColumnName === "start_time" ||
            field.ColumnName === "event_end_time"
          ) {
            return undefined;
          }
          return (
            <IonItem key={index}>
              <IonLabel
                position={
                  field.ColumnName === "failure_flag" ||
                  field.ColumnName === "followup_required_flag"
                    ? undefined
                    : "stacked"
                }
              >
                {field.TranslatedIdText}
                {field.IsRequired && "*"}
              </IonLabel>
              {field.ColumnName === "user_id" &&
                (field.ElementType === "Dropdown" ? (
                  <IonIcon
                    ios={caretDownOutline}
                    md={caretDownSharp}
                    slot="end"
                    style={{ fontSize: "15px", alignSelf: "center" }}
                    onClick={() => setShowModal(true)}
                  />
                ) : null)}
              {field.ColumnName === "status" && (
                <IonSelect
                  interface="popover"
                  value={status}
                  onIonChange={(ev) => {
                    setStatus(ev.detail.value);
                  }}
                >
                  {validStatusValues.map((value, index) => {
                    return (
                      <IonSelectOption key={index} value={value.Code}>
                        {value.Code}
                        {!!value.Description && ` - ${value.Description}`}
                      </IonSelectOption>
                    );
                  })}
                </IonSelect>
              )}
              {field.ColumnName === "user_id" ? (
                field.ElementType === "Dropdown" ? (
                  <React.Fragment>
                    <IonInput
                      readonly={field.ElementType === "Dropdown"}
                      onClick={() => setShowModal(true)}
                    >
                      {userId}
                    </IonInput>
                    <IonModal isOpen={showModal}>
                      <IonHeader>
                        <IonToolbar>
                          <IonTitle>Select Employee</IonTitle>
                          <IonButtons slot="end">
                            <IonButton onClick={handleClose}>Close</IonButton>
                          </IonButtons>
                        </IonToolbar>
                      </IonHeader>
                      <IonContent>
                        <IonItem>
                          <IonInput
                            placeholder="Filter Employees"
                            onIonChange={(e) => setFilter(e.detail.value!)}
                            value={filter}
                          ></IonInput>
                          <IonIcon
                            slot="end"
                            ios={filterCircleOutline}
                            md={filterCircleSharp}
                          ></IonIcon>
                        </IonItem>
                        <IonRadioGroup
                          value={selectedEmployee}
                          onIonChange={handleRadioChange}
                        >
                          {filteredReviewerList.map((employee, index) => (
                            <IonItem key={index}>
                              <IonLabel>
                                {employee.Code} - {employee.Description}
                              </IonLabel>
                              <IonRadio slot="start" value={employee.Code} />
                            </IonItem>
                          ))}
                        </IonRadioGroup>
                      </IonContent>
                      <IonFooter>
                        <IonButton expand="block" onClick={handleOk}>
                          OK
                        </IonButton>
                        <IonButton
                          fill="outline"
                          expand="block"
                          onClick={handleClose}
                        >
                          Cancel
                        </IonButton>
                      </IonFooter>
                    </IonModal>
                  </React.Fragment>
                ) : field.ElementType === "ISS" ? (
                  <React.Fragment>
                    <IonInput
                      value={userId}
                      onIonInput={(ev) => {
                        onFilterModalConfirm(ev.target.value);
                        handleEmployeeSearch(ev);
                      }}
                    ></IonInput>

                    <IonIcon
                      slot="end"
                      ios={searchOutline}
                      md={searchSharp}
                      style={{ fontSize: "20px", alignSelf: "center" }}
                      onClick={async () => {
                        resetSearchState();
                        setFilterModalColumnName("employee_id");
                        const response: ApiResponse =
                          await getValueSearchDetails({
                            tableName: "em_employee",
                            columnName: "employee_id",
                          });
                        const data = {
                          tableName: "em_employee",
                          columnName: "employee_id",
                        };
                        logCustomMessage(
                          "Showing query wizard in Completion window.",
                          SeverityLevel.Information,
                          "QueryDesigner/GetValueSearchDetails",
                          data,
                          response
                        );
                        if (response.status === 200) {
                          setFilterModalModuleName(
                            response.data.QueryWizardModuleName
                          );
                          setIsFilterModalOpen(true);
                        }
                      }}
                    ></IonIcon>
                  </React.Fragment>
                ) : null
              ) : null}
              {field.ColumnName === "start_date" && (
                <IonInput
                  type="datetime-local"
                  value={startDateTime}
                  disabled={field.IsProtected}
                  onIonChange={(ev) => {
                    setStartDateTime(ev.detail.value || undefined);
                  }}
                />
              )}
              {field.ColumnName === "event_end_date" && (
                <IonInput
                  type="datetime-local"
                  value={endDateTime}
                  disabled={field.IsProtected}
                  onIonChange={(ev) => {
                    setEndDateTime(ev.detail.value || undefined);
                  }}
                />
              )}
              {field.ColumnName === "production_lost" && (
                <IonInput
                  type="number"
                  value={lostProduction}
                  onIonChange={(ev) => {
                    setLostProduction(ev.detail.value || undefined);
                  }}
                  placeholder={field.TranslatedIdText}
                />
              )}
              {field.ColumnName === "production_uom" && (
                <IonInput
                  maxlength={field.MaxSize}
                  value={productionUom}
                  onIonChange={(ev) => {
                    setProductionUom(ev.detail.value || undefined);
                  }}
                  placeholder={field.TranslatedIdText}
                />
              )}
              {field.ColumnName === "failure_flag" && (
                <IonToggle
                  slot="end"
                  checked={failure}
                  onIonChange={(ev) => {
                    setFailure(ev.detail.checked);
                  }}
                />
              )}
              {field.ColumnName === "followup_required_flag" && (
                <IonToggle
                  slot="end"
                  checked={followUpFlag}
                  onIonChange={(ev) => {
                    setFollowUpFlag(ev.detail.checked);
                  }}
                />
              )}
              {field.ColumnName === "remarks" && (
                <IonInput
                  value={comments}
                  onIonChange={(ev) => {
                    setComments(String(ev.detail.value));
                  }}
                  placeholder={field.TranslatedIdText}
                />
              )}
            </IonItem>
          );
        })}
        <IonButton
          expand="full"
          color="primary"
          disabled={
            !status || !startDateTime || (commentField?.IsRequired && !comments)
          }
          onClick={onSubmit}
        >
          {translations["lbl_btn_complete"] || "Complete"}
        </IonButton>
      </IonList>
      <ISSPopover
        popover={popover}
        popoverOpen={popoverOpen}
        setPopoverOpen={setPopoverOpen}
        searchResults={searchResults}
        setSearchResults={setSearchResults}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        setElementValue={setUserId}
      />
      {(objectID || buttonClicked) && (
        <TimeEntry
          isOpen={isModalOpen}
          cancel={onModalCancel}
          confirm={onModalConfirm}
          objectID={objectID}
        />
      )}
      <IonFab vertical="bottom" horizontal="end" slot="fixed">
        <IonFabButton
          disabled={!timeAccess}
          onClick={() => {
            setButtonClicked(true);
            setObjectID("");
            setIsModalOpen(true);
          }}
        >
          <IonIcon icon={add}></IonIcon>
        </IonFabButton>
      </IonFab>
    </>
  );
};

export default withAITracking(reactPlugin, CompletionData, "CompletionData");
